import { useEffect, useState } from "react"
import { useNavigate } from 'react-router-dom';
import Swal from 'sweetalert2'
import { toast } from 'react-toastify';

export const useActions = ({
    //------------- Generales
    marvarApi, dispatch, user, onLogout, location, paramsURL, toggleOpen, toggleClose,
    //------------- globalStates
    globalStates,
    //------------- defalutData
    defaultData, 
    //------------- Helpers
    Helpers,
    //------------- Forms
    Forms,
    //------------- FetchData
    FetchData
}) =>{

    // Para redirigir a otras pantallas
    const navigate = useNavigate();

    // ------------------------------------ DEMO MODAL
    const openModal = (_, title, compont, dataRequest) => {
        toggleOpen(_, title, compont, dataRequest)
    }
    
    const closeModal = () => {
        toggleClose()
    }

    const handleClickDemoModal = async (_, title, compont, dataRequest) => {
        openModal(_, title, compont, dataRequest)
    }

    // ------------------------------------ DEMO MODAL

    const handleClickShowForm = (flag) => {
        const { setShowForm } = globalStates
        setShowForm(flag)
    }

    // Cancela la visualizacion del formulario al darle click al botón "Cancelar"
    const handleClickHideForm = () => {

        const { FormScreen } = Forms
        const { onResetForm } = FormScreen

        onResetForm()
        handleClickShowForm(false)

    }

    const handleClickFetchAllVehicleReception = async () => {

        const { fetchAllVehicleReception } = FetchData
        const { executeFetch } = fetchAllVehicleReception

        executeFetch()

    }

    const handleClickFetchSpecificVehicleReception = async (idreception, formOpeningMode) => {
        console.log('[useActions][handleClickFetchSpecificVehicleReception] idreception, formOpeningMode ::: ', {idreception, formOpeningMode})
        
        const { setFormOpeningMode } = globalStates
        const { FormScreen } = Forms
        const { onResetForm } = FormScreen

        const { fetchSpecificVehicleReception } = FetchData
        const { setParamsToSearch, executeFetch } = fetchSpecificVehicleReception

        // Reseteamos el formulario para limpiar cualquier rastro de una busqueda anterior
        onResetForm()
        
        // Seteamos los parametros para filtrar info y ejecutamos el fetch
        setParamsToSearch({idreception: idreception})
        executeFetch()

        setFormOpeningMode(formOpeningMode)
        handleClickShowForm(true)

    }

    const handleClickDeleteVehicleReception = async (idreception) => {

        Swal.fire({
            title: '¿Está seguro de eliminar este registro?',
            text: 'Esta acción no se puede deshacer, haga click en "Eliminar" para continuar',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#ff6219',
            cancelButtonText: 'Cancelar',
            confirmButtonText: 'Eliminar',
        }).then(async result => {
            if (result.isConfirmed) {
                await marvarApi.delete(`/legal/delete-vehicle-reception/${idreception}`)
                .then(({ data }) => {
                    
                    alertMessage(data)
                    handleClickFetchAllVehicleReception()

                })
                .catch(error => {
                    console.log('API ERROR: ', error)
                })
            }
        })
        
    }

    const handleClickReturnStep = () => {
        const { stepApplilication, setStepApplilication} = globalStates
        setStepApplilication(stepApplilication-1)
    }

    const handleClickNextStep = () => {
        const { stepApplilication, setStepApplilication} = globalStates
        setStepApplilication(stepApplilication+1)
    }

    const handleClickCloseForm = () => {
        const { setStepApplilication } = globalStates
        const { FormScreen, FormFiles, FormOtherExpense } = Forms
        FormScreen.onResetForm()
        FormFiles.onResetForm()
        FormOtherExpense.onResetForm()
        setStepApplilication(0)

        handleClickShowForm(false)
    }

    const handleClickCleanUpFiles = (event) => {
        const { FormFiles } = Forms
        const { setFormState } = FormFiles

        const { fetchAllDeposits } = FetchData
        const { executeFetchAllDeposits } = fetchAllDeposits

        setFormState(prevState => ({
            ...prevState,
            fileRejections: [],
            acceptedFiles: []
        }))

        executeFetchAllDeposits()

    }

    const handleClickDeleteDocument = (iddocumento) => {
        
        const { fetchAllFiles } = FetchData

        Swal.fire({
            title: '¿Desea eliminar este registro?',
            showConfirmButton: true,
            showCancelButton: true,
            confirmButtonText: 'Eliminar',
            cancelButtonText: 'Cancelar'
        }).then(async result => {
            if (result.isConfirmed) {
                await marvarApi.delete(`/legal/delete-document-by-vehicle-reception/${iddocumento}`)
                    .then( ({ data }) => {
                        alertMessage(data)
                        console.log(data)
                        if (data.flag === 'OK') {
                            fetchAllFiles.executeFetch()
                            console.log('aqui')
                            // closeModal()
                        }else{
                            
                        }
                    }).catch(error => {
                        console.log('API ERROR: ', error)
                    })
            }
        })
    }

    const handleClickTariff = (event) => {
        
        const { FormScreen } = Forms
        const { setFormState } = FormScreen
        
        const jsonRate = JSON.parse(event.target.value || {})
        setFormState(prevState => ({
            ...prevState,
            [ event.target.name ] : event.target.value,
            idrate: jsonRate.idrate,
            info_rate: jsonRate.costo
        }))

    }

    const handleClickFetchAllExpenseReception = async () => {

        const { fetchAllExpenseReception } = FetchData
        const { executeFetch } = fetchAllExpenseReception

        executeFetch()

    }

    const handleClickFetchSpecificExpenseReception = async (idexpensereception) => {
        
        const { fetchSpecificExpenseReception } = FetchData
        const { setParamsToSearch, executeFetch } = fetchSpecificExpenseReception

        // Reseteamos el formulario para limpiar cualquier rastro de una busqueda anterior
        handleClickResetOtherExpenseForm()
        
        // Seteamos los parametros para filtrar info y ejecutamos el fetch
        setParamsToSearch({idexpensereception: idexpensereception})
        executeFetch()


    }

    const handleClickDeleteExpenseReception = async (idexpensereception) => {

        const { fetchAllExpenseReception } = FetchData
        const { FormOtherExpense } = Forms
        const { formState } = FormOtherExpense

        Swal.fire({
            title: '¿Está seguro de eliminar este registro?',
            text: 'Esta acción no se puede deshacer, haga click en "Eliminar" para continuar',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#ff6219',
            cancelButtonText: 'Cancelar',
            confirmButtonText: 'Eliminar',
        }).then(async result => {
            if (result.isConfirmed) {
                await marvarApi.delete(`/legal/delete-expense-reception/${idexpensereception}`)
                .then(({ data }) => {
                    
                    alertMessage(data)
                    handleClickFetchAllExpenseReception()
                    fetchAllExpenseReception.setParamsToSearch({idreception: formState.idreception})
                    fetchAllExpenseReception.executeFetch()

                })
                .catch(error => {
                    console.log('API ERROR: ', error)
                })
            }
        })
        
    }
    
    const handleClickResetOtherExpenseForm = async () => {

        const { FormOtherExpense } = Forms
        const { setFormState } = FormOtherExpense

        setFormState(prevState => ({
            ...prevState,
            idexpense: '',
            costo: '',
            observation: ''
        }))
        
    }

    const handleClickAddPayment = async (idreception) => {
        navigate(`/juridico/predio-judicial/pagos/${idreception}`)
    }

    const handleClickPrintExitPass = async (idreception) => {
        // console.log('[useActions][handleClickPrintExitPass] idreception', idreception)

        const { FormScreen } = Forms
        const { onResetForm } = FormScreen

        const { fetchSpecificVehicleReception } = FetchData

        // Reseteamos el formulario para limpiar cualquier rastro de una busqueda anterior
        onResetForm()
        
        // Seteamos los parametros para filtrar info y ejecutamos el fetch
        fetchSpecificVehicleReception.setParamsToSearch({
            idreception: idreception,
            printExitPassFlag: true
        })
        fetchSpecificVehicleReception.executeFetch()

        openModal('', 'VISOR DE REPORTE', 'ReportViewer', { docType: 'EXIT_PASS' })
    }

    const handleClickContinue = async () => {
        const { fetchAllFiles, fetchAllExpenseReception } = FetchData
        const { FormScreen, FormOtherExpense, FormFiles } = Forms

        fetchAllFiles.setParamsToSearch({idreception: FormScreen.formState.idreception})
        fetchAllFiles.executeFetch()

        FormOtherExpense.formState.idreception = FormScreen.formState.idreception
        FormFiles.formState.idreception = FormScreen.formState.idreception
        fetchAllExpenseReception.setParamsToSearch({idreception: FormScreen.formState.idreception})
        fetchAllExpenseReception.executeFetch()

        handleClickNextStep()
    }
    
    const onSubmitForm = async (e) => {

        e.preventDefault()

        const { fetchAllFiles, fetchAllExpenseReception } = FetchData
        const { FormScreen, FormOtherExpense, FormFiles } = Forms
        const { formState } = FormScreen

        const _dataBody = {
            idreception: formState.idreception,
            idauthority: formState.idauthority,
            idrate: formState.idrate,
            idlocation: formState.idlocation,
            vehicle_placa: formState.vehicle_placa,
            vehicle_marca: formState.vehicle_marca,
            vehicle_linea: formState.vehicle_linea,
            vehicle_color: formState.vehicle_color,
            vehicle_modelo: formState.vehicle_modelo,
            vehicle_chasis: formState.vehicle_chasis,
            vehicle_motor: formState.vehicle_motor,
            info_rate: formState.info_rate,
            info_numero_diligencia: formState.info_numero_diligencia,
            info_numero_proceso: formState.info_numero_proceso,
            info_cliente: formState.info_cliente,
            info_dpi: formState.info_dpi,
            info_motivo_recepcion: formState.info_motivo_recepcion,
            info_tiene_llaves: formState.info_tiene_llaves,
            info_observaciones: formState.info_observaciones,
            info_fecha_ingreso: formState.info_fecha_ingreso,
            info_flag_cancelado: formState.info_flag_cancelado,
            user: user.username
        }

        // console.log('[useActions][onSubmitForm] _dataBody ', _dataBody)

        if(_dataBody.idreception > 0){

            await marvarApi.put( `/legal/update-vehicle-reception/${_dataBody.idreception}`, _dataBody )
                .then(({ data }) => {

                    alertMessage(data)
                    handleClickFetchAllVehicleReception()
                    
                    fetchAllFiles.setParamsToSearch({idreception: formState.idreception})
                    fetchAllFiles.executeFetch()

                    FormOtherExpense.formState.idreception = formState.idreception
                    FormFiles.formState.idreception = formState.idreception
                    fetchAllExpenseReception.setParamsToSearch({idreception: formState.idreception})
                    fetchAllExpenseReception.executeFetch()

                    handleClickNextStep()

                })
                .catch(error => {
                    console.log('API ERROR: ', error)
                })

        }else{

            await marvarApi.post( `/legal/create-vehicle-reception`, _dataBody )
                .then(({ data }) => {

                    console.log('post: /legal/create-vehicle-reception ', data)
                    
                    alertMessage(data)

                    if (data.flag === 'OK') {
                        const idreception = data.rows[0].insertId
                        
                        formState.idreception = idreception
                        fetchAllFiles.setParamsToSearch({idreception: idreception})
                        fetchAllFiles.executeFetch()
                        
                        FormOtherExpense.formState.idreception = idreception
                        FormFiles.formState.idreception = idreception
                        fetchAllExpenseReception.setParamsToSearch({idreception: formState.idreception})
                        fetchAllExpenseReception.executeFetch()
                        handleClickFetchAllVehicleReception()

                        handleClickNextStep()
                    }

                })
                .catch(error => {
                    console.log('API ERROR: ', error)
                })

        }
    }

    const onSubmitFormFiles = async (e) => {
        
        // e.preventDefault()
        const { FormFiles } = Forms
        const { formState, setFormState } = FormFiles
        
        const { fetchAllFiles } = FetchData
        
        if(formState.acceptedFiles.length === 0){
            Swal.fire({
                icon: 'error',
                title: 'ERROR!!',
                text: 'Debe seleccionar al menos un documento para subir'
            })
            return
        }        

        const _data = new FormData();

        _data.append('idreception', formState.idreception);
        _data.append('user', user.name)


        formState.acceptedFiles.forEach((file, index) => {
            _data.append(`attachmentt`, file);
        });

        // console.log('[useActions][onSubmitFormFiles] formState ', formState )
        console.log('[useActions][onSubmitFormFiles] _data ', Object.fromEntries(_data.entries()) )
        
        await marvarApi.post(`/legal/save-documents-by-vehicle-reception`, _data )
            .then(({ data }) => {

                if (data.flag === 'OK') {
                    setFormState(prevState => ({
                        ...prevState,
                        acceptedFiles : [],
                        fileRejections : []
                    }))
                    fetchAllFiles.executeFetch()
                }
                    alertMessage(data)
                })
            .catch(error => {
                console.log('API ERROR: ', error)
                setFormState(prevState => ({
                    ...prevState,
                    acceptedFiles : [],
                    fileRejections : []
                }))
            })
    }

    const onSubmitOtherExpensesForm = async (e) => {

        e.preventDefault()

        const { fetchAllExpenseReception } = FetchData
        const { FormOtherExpense } = Forms
        const { formState } = FormOtherExpense

        const _dataBody = {
            idexpensereception: formState.idexpensereception,
            idreception: formState.idreception,
            idexpense: formState.idexpense,
            costo: formState.costo,
            observation: formState.observation,
            user: user.username
        }

        console.log('[useActions][onSubmitForm] _dataBody ', _dataBody)

        if(_dataBody.idexpensereception > 0){

            await marvarApi.put( `/legal/update-expense-reception/${_dataBody.idexpensereception}`, _dataBody )
                .then(({ data }) => {
                    alertMessage(data)
                    handleClickFetchAllVehicleReception()
                    fetchAllExpenseReception.setParamsToSearch({idreception: formState.idreception})
                    fetchAllExpenseReception.executeFetch()
                    handleClickResetOtherExpenseForm()
                })
                .catch(error => {
                    console.log('API ERROR: ', error)
                })

        }else{

            await marvarApi.post( `/legal/create-expense-reception`, _dataBody )
                .then(({ data }) => {
                    alertMessage(data)
                    if (data.flag === 'OK') {
                        handleClickFetchAllVehicleReception()
                        fetchAllExpenseReception.setParamsToSearch({idreception: formState.idreception})
                        fetchAllExpenseReception.executeFetch()
                        handleClickResetOtherExpenseForm()
                    }
                })
                .catch(error => {
                    console.log('API ERROR: ', error)
                })

        }
    }

    const onSubmitReturnCertificateModal = (idreception) => {

        const { ReturnCertificateForm } = Forms
        const { fetchSpecificVehicleReception } = FetchData
        
        if (ReturnCertificateForm.formState.nameToReturnToAdd === '') {
            const messageCustom = {
                message: 'No ha ingresado el nombre la persona que emite',
                title: 'FAIL',
                rows: []
            }
            alertMessage(messageCustom)    
            return
        }
        
        if (ReturnCertificateForm.formState.addressToAdd === '') {
            const messageCustom = {
                message: 'No ha ingresado la dirección',
                title: 'FAIL',
                rows: []
            }
            alertMessage(messageCustom)    
            return
        }

        if (ReturnCertificateForm.formState.phoneToAdd === '') {
            const messageCustom = {
                message: 'No ha ingresado el teléfono',
                title: 'FAIL',
                rows: []
            }
            alertMessage(messageCustom)    
            return
        }

        
        // const cleanText = ReturnCertificateForm.formState.textToAdd.replace(/\r?\n|\r/g, " ")
        
        // Seteamos los parametros para filtrar info y ejecutamos el fetch
        fetchSpecificVehicleReception.setParamsToSearch({
            idreception: idreception,
            printReturnCertificate: {
                flag: true,
                nameToReturnToAdd: ReturnCertificateForm.formState.nameToReturnToAdd,
                addressToAdd: ReturnCertificateForm.formState.addressToAdd,
                phoneToAdd: ReturnCertificateForm.formState.phoneToAdd
            }
        })
        fetchSpecificVehicleReception.executeFetch()
        
        ReturnCertificateForm.onResetForm()
        closeModal()

        openModal('', 'VISOR DE REPORTE', 'ReportViewer', { docType: 'RETURN_CERTIFICATE' })

    }
    
    const onSubmitExistPassModal = (idreception) => {

        const { ExitPassForm } = Forms
        const { fetchSpecificVehicleReception } = FetchData
        
        if (ExitPassForm.formState.titularTextToAdd === '') {
            const messageCustom = {
                message: 'No ha ingresado al titular que va a retirar',
                title: 'FAIL',
                rows: []
            }
            alertMessage(messageCustom)    
            return
        }

        if (ExitPassForm.formState.observationsToAdd === '') {
            const messageCustom = {
                message: 'No ha ingresado las observaciones',
                title: 'FAIL',
                rows: []
            }
            alertMessage(messageCustom)    
            return
        }

        
        const cleanText = ExitPassForm.formState.observationsToAdd.replace(/\r?\n|\r/g, " ")
        
        // Seteamos los parametros para filtrar info y ejecutamos el fetch
        fetchSpecificVehicleReception.setParamsToSearch({
            idreception: idreception,
            printExitPass: {
                flag: true,
                titularTextToAdd: ExitPassForm.formState.titularTextToAdd,
                observationsToAdd: cleanText
            }
        })
        fetchSpecificVehicleReception.executeFetch()
        
        ExitPassForm.onResetForm()
        closeModal()

        openModal('', 'VISOR DE REPORTE', 'ReportViewer', { docType: 'EXIT_PASS' })

    }

    return Object.freeze({
        openModal,
        closeModal,
        handleClickDemoModal,
        
        handleClickShowForm,
        handleClickHideForm,
        handleClickFetchAllVehicleReception,
        handleClickFetchSpecificVehicleReception,
        handleClickDeleteVehicleReception,
        handleClickReturnStep,
        handleClickNextStep,
        handleClickCloseForm,
        handleClickCleanUpFiles,
        handleClickDeleteDocument,
        handleClickTariff,
        handleClickFetchAllExpenseReception,
        handleClickFetchSpecificExpenseReception,
        handleClickDeleteExpenseReception,
        handleClickResetOtherExpenseForm,
        handleClickAddPayment,
        handleClickPrintExitPass,
        handleClickContinue,
        onSubmitForm,
        onSubmitFormFiles,
        onSubmitOtherExpensesForm,
        onSubmitReturnCertificateModal,
        onSubmitExistPassModal
    })
}

/**
 * Funcion para gestionar las alertas de toastify
 * @param {*} res : respuesta del API / custom (debe ser un json "{}")
 * @param {*} toggle : toggle de modal
 */
const alertMessage = (res, toggle) => {

    if (res) {
        const { flag, message } = res
        if (flag === 'OK') {
            toast.success(message, {
                position: "top-right",
                theme: "colored"
            })
            toggle && toggle()
        } else {
            toast.warn(message, {
                position: "top-right",
                theme: "colored",
                autoClose: false,
            })
        }
    } else {
        toast.warn('Error interno, notifique a Soporte técnico!.', {
            position: "top-right",
            theme: "colored",
            autoClose: false,
        })
    }
}